import { useGetCompanyById } from '@sit/client-shared';
import Box from 'carbon-react/lib/components/box';
import Heading from 'carbon-react/lib/components/heading';
import { Outlet } from 'react-router';
import GoBackButton from '../../components/GoBackButton';
import { CompanyNavigationBar } from './CompanyNavigationBar';
import { useCompanyTreeSettingsIdInPathParams } from './helpers';

export function CompanyPage() {
  const companyTreeSettingsId = useCompanyTreeSettingsIdInPathParams();
  const {
    data: company,
    isPending,
    error,
  } = useGetCompanyById({
    companyTreeSettingsId,
  });

  return (
    <div className="intacct-admin">
      <Box display="flex">
        <GoBackButton url="/companies" width="auto" />
        <Heading
          title={
            error
              ? error.message
              : `Company - ${isPending ? 'Loading...' : company.externalId}`
          }
          divider={false}
        />
      </Box>
      <div id="sticky-container" style={{ height: '100px' }}>
        <CompanyNavigationBar />
        <div className="intacct-admin-inner-container">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
